export default interface VCustomer {
  id: number;
  reservationAccUnitGuestId: number;
  tenantId: number;
  isLegalEntity: boolean;
  orderByName: string;
  name: string;
  eMail: string;
  telephoneNumber: string;
  dateOfBirth?: Date | string;  
  identificationNumber: string;
  identificationDocumentTypeId?: number;
  countryOfResidenceId?: number;
  countryOfResidenceName?: string;
  city?: string;
  remarks: string;
  numberOfReservations?: number;
  numberOfStays?: number;
  numberOfNights?: number;
  numberOfCancelations?: number;
  numberOfNoShows?: number;
  totalIncomeAmount?: number;
  dueAmount?: number;
}

export class CustomerModel {
  id!: number;
  reservationAccUnitGuestId!: number;
  isLegalEntity!: boolean;

  genderId = 3; //default value - 1(Male), 2(Female), 3(Unknown)
  firstName?: string;
  middleName?: string;
  lastName?: string;
  legalEntityName?: string;
  businessId?: string;
  eMail?: string;
  telephoneNumber?: string;

  streetName?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;

  countryOfResidenceId?: number;
  countryOfBirthId?: number;
  citizenshipId?: number;
  dateOfBirth?: Date | string;

  identificationDocumentNumber?: string;
  identificationDocumentTypeId?: number;

  ownerPaysVAT = false;
  isOwner = false;

  remarks?: string;

  externalCustomerCode?: string;
  bankAccountNumber?: string;

  isResident = true;

  vatId?: string;

  isForOwner = false;
  isForPropertyManager = false

  preferredLanguageId?: number;
}